import { SxProps } from "@mui/material";

export const sxTextField: SxProps = {
	width: '60%',
	input: {
		fontFamily: 'Unimed-Sans', 
		color: '#383838', 
		fontSize: '14px', 
	},
	'@media (max-width: 899px)': {
		width: '85vw'
	}
}

export const sxTable: SxProps = {
    borderRadius: '10px',
    width: '80%',
    '@media (max-width: 899px)': {
        width: '85vw'
    },
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '578px',
    width: '85%',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px',
    gap: '24px',
}

export const sxCalendar: SxProps = {

    width: '100%',
    ".MuiDateCalendar-root": {
        backgroundColor: '#00995D',
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08);'
    },
    ".MuiPickersCalendarHeader-root": {
        backgroundColor: '#00995D',
        color: '#fff',
        textTransform: 'uppercase',
        borderRadius: '10px 10px 0px 0px',
        paddingTop: '15px',
        paddingBottom: '15px',
        margin: '0',
        maxHeight: 'none',
    },
    ".MuiPickersCalendarHeader-labelContainer": {
        fontFamily: 'Unimed-Sans',
        fontWeight: '700',

    },
    ".MuiDayCalendar-root": {
        backgroundColor: "#fff"
    },
    ".MuiPickersCalendarHeader-switchViewButton": {
        color: '#fff'
    },
    ".MuiPickersArrowSwitcher-button": {
        color: '#fff'
    },
    ".MuiDayCalendar-weekDayLabel": {
        fontFamily: 'Unimed-Sans',
        fontWeight: '700',
        color: '#4C4C4C'
    },
    ".MuiPickersDay-root": {
        fontFamily: 'Unimed-Sans',
        color: '#4C4C4C',
        backgroundColor: '#fff'
    },
    "MuiPickersDay-root:focus": {
        backgroundColor: '#00995D'
    },
    "MuiPickersDay-root:hover": {
        backgroundColor: '#000'
    },
    ".MuiPickersYear-yearButton": {
        fontFamily: 'Unimed-Sans',
        color: '#4C4C4C'
    },
    ".Mui-selected": {
        backgroundColor: '#00995D',
        color: "#fff"
    },
    ".Mui-selected:focus": {
        backgroundColor: '#00995D'
    },
    ".Mui-selected:hover": {
        backgroundColor: '#00995D'
    },
    ".Mui-disabled": {
        background: 'none'
    },
    '.MuiButton:hover .MuiButton-contained': {
        backgroundColor: '#00995D',
    }
}

export const sxCalendarContrast: SxProps = {
    ...sxCalendar,
      '& .MuiInputBase-root': {
        backgroundColor: 'black',
        color: 'white',
      },
      '& .MuiSvgIcon-root': {
        color: 'white',
      },
  }

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px '
}